import tw from 'twin.macro';

export const SecondaryButton = tw.button`text-xs text-plutoblue-500 px-4 py-2 font-bold h-auto w-auto border  dark:text-white bg-transparent dark:hover:border-gray-500  hover:border-plutoblue-500  rounded-full text-center transition-all`;
